/* eslint-disable no-use-before-define */
import React from 'react'
import { useQuickScreener } from './use-quick-screener'
import { fmt } from '../../twd'
import { toSearchParams } from './to-search-params'

export default ({errors, values}) => {

    const { state, ajax } = useQuickScreener()
    const timerId = React.useRef()
    const lastBody = React.useRef(state.lastBody)
    const lastAbort = React.useRef()
    const hasError = Object.keys(errors).length>0
    const buttonRef = React.useRef()

    React.useEffect(() => {

        if (timerId.current) {
            clearInterval(timerId.current)
            timerId.current = 0
        }

        timerId.current = setTimeout(async () => {
            if (hasError) return

            let p = Object.assign({
                searchType:'offers',
                pageNumber:1,
                resultsPerPage: 1,
                persistToPreviousSearches: false,
                marketCheckRequired: false,
                sort: [{
                    field: 'holdMaturitySortDt',
                    direction: 'ASC'
                }]
            }, toSearchParams(values))

            let body = JSON.stringify(p)
            if (lastBody.current === body) return

            lastBody.current = body
            state.lastBody = body

            try {
                if (lastAbort.current) {
                    lastAbort.current()
                }

                let { data, abort } = await ajax({
                    url:'/esb/portfolio/offersearch/getHitCount',
                    method: 'POST',
                    body
                })

                updateText(null)
                lastAbort.current = abort
                let { resultSetCount } = await data
                lastAbort.current = null
                updateText(resultSetCount)

            } catch(e) {
                updateText(null)
            }

        }, 1000)

        return () => {
            if (lastAbort.current) lastAbort.current()
            if (timerId.current) clearInterval(timerId.current)
            updateText(state.count)
        }
    })

    const updateText = (count) => {
        if (!buttonRef.current) return
        if (count===null || count===undefined) {
            buttonRef.current.innerHTML = 'View results'
            return
        }

        let s = `View (${fmt.count(count)}) results`
        buttonRef.current.innerHTML = s
        state.count = count
    }

    return <button
        ref={buttonRef}
        type="submit"
        disabled={hasError}
        className="btn btn-primary btn-block">
            View results
        </button>
}
